function parseAppVersion(user_agent: string): string {
  const exp_match = user_agent.match(/FBK\/([0-9.]*)/);
  if (exp_match) {
    return exp_match[0].split('/')[1];
  }

  return '';
}

export const isFbkApp = () => {
  const user_agent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
  const app_version = parseAppVersion(user_agent);
  if (app_version !== '') {
    return true;
  }
  return false;
};
